<template>
  <el-dialog
    title='修改密碼'
    :visible.sync="innerVisible"
    append-to-body
  >
    <el-form :model="form" ref="form" :rules="rules">

      <el-form-item label="原始密碼" :label-width="formLabelWidth" prop="oldPassword">
        <el-input
          type="password"
          v-model="form.oldPassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>


      <el-form-item label="密碼" :label-width="formLabelWidth" prop="password">
        <el-input
          type="password"
          v-model="form.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="確認密码"
        prop="checkPassword"
        :label-width="formLabelWidth"
      >
        <el-input
          type="password"
          v-model="form.checkPassword"
          autocomplete="off"
        ></el-input>
      </el-form-item>

    </el-form>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import API from "../api"
export default {
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    var validatePass = (_, value, callback) => {
      if (value === "") {
        callback(new Error("請輸入新密碼"));
      } else {
        if (this.form.checkPassword !== "") {
          this.$refs.form.validateField("checkPassword");
        }
        callback();
      }
    };
    var validatePass2 = (_, value, callback) => {
      if (value === "") {
        callback(new Error("請再次輸入密碼"));
      } else if (value !== this.form.password) {
        callback(new Error("兩次輸入密碼不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        oldPassword: [
          { required: true, message: "請輸入原始密碼", trigger: "blur" },
        ],
        password: [
          //{ required: true, message: '請輸入管理密碼', trigger: 'blur' },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPassword: [
          //{ required: true, message: '請確認管理密碼', trigger: 'blur' },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      formLabelWidth: "100px",
      form: {
        oldPassword: "",
        password: "",
        checkPassword: "",
      },
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const params = {
            newPassword: this.form.password,
            originalPassword: this.form.oldPassword,
          }
          API.my.changePasswd(params).then(() => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.innerVisible = false;
          })
          .catch(() => {
            /*this.$message({*/
            /*type: 'info',*/
            /*message: `修改失敗：${err}`*/
            /*});          */
          });
        }
        else {
          return false;
        }
      });
    },
  },
};
</script>

<style></style>
